import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export default function RxNmatch(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        id="Layer_1"
        enable-background="new 0 0 60 60"
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <g transform="matrix(1,0,0,1,0,0)">
          <g>
            <g>
              <path
                d="m41.4667969 53.9987793h-30.6894531c-2.2929688 0-4.1582031-1.8652344-4.1582031-4.1582031v-39.6811524c0-2.2929688 1.8652344-4.1582031 4.1582031-4.1582031h27.53125c2.2929688 0 4.1582031 1.8652344 4.1582031 4.1582031v25.6889648c0 .5522461-.4472656 1-1 1s-1-.4477539-1-1v-25.6889648c0-1.1899414-.9677734-2.1582031-2.1582031-2.1582031h-27.53125c-1.1904297 0-2.1582031.9682617-2.1582031 2.1582031v39.6811523c0 1.1899414.9677734 2.1582031 2.1582031 2.1582031h30.6894531c.5527344 0 1 .4477539 1 1s-.4472656 1.0000001-1 1.0000001z"
                fill="#19191a"
                fill-opacity="1"
                data-original-color="#b4b0b9ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m13.7509766 30.1052246c-.5527344 0-1-.4477539-1-1v-16.2685547c0-.5522461.4472656-1 1-1s1 .4477539 1 1v16.2685547c0 .5522461-.4472657 1-1 1z"
                fill="#5c5c5c"
                fill-opacity="1"
                data-original-color="#706b78ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m17.8164063 21.9685059h-4.0654297c-.5527344 0-1-.4477539-1-1v-8.1318359c0-.5522461.4472656-1 1-1h4.0654297c2.7939453 0 5.0664063 2.2724609 5.0664063 5.065918 0 1.3540039-.5273438 2.6264648-1.484375 3.5825195-.9423829.9545898-2.216797 1.4833984-3.5820313 1.4833984zm-3.0654297-2h3.0654297c.8261719 0 1.5947266-.3173828 2.1630859-.8935547.5839844-.5834961.9033203-1.3530273.9033203-2.1723633 0-1.6904297-1.3759766-3.065918-3.0664063-3.065918h-3.0654297v6.131836z"
                fill="#5c5c5c"
                fill-opacity="1"
                data-original-color="#706b78ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m16.8476563 34.505127c-.2558594 0-.5117188-.0976563-.7070313-.2929688-.390625-.390625-.390625-1.0234375 0-1.4140625l9.703125-9.7026367c.390625-.390625 1.0234375-.390625 1.4140625 0s.390625 1.0234375 0 1.4140625l-9.703125 9.7026367c-.1953125.1953125-.4511719.2929688-.7070312.2929688z"
                fill="#5c5c5c"
                fill-opacity="1"
                data-original-color="#706b78ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m26.5507813 34.505127c-.2558594 0-.5117188-.0976563-.7070313-.2929688l-9.703125-9.7026367c-.390625-.390625-.390625-1.0234375 0-1.4140625s1.0234375-.390625 1.4140625 0l9.703125 9.7026367c.390625.390625.390625 1.0234375 0 1.4140625-.1953125.1953125-.4511719.2929688-.7070312.2929688z"
                fill="#5c5c5c"
                fill-opacity="1"
                data-original-color="#706b78ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m29.4726563 39.5773926h-16.1796875c-.5527344 0-1-.4477539-1-1s.4472656-1 1-1h16.1796875c.5527344 0 1 .4477539 1 1s-.4472657 1-1 1z"
                fill="#19191a"
                fill-opacity="1"
                data-original-color="#b4b0b9ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m29.4726563 43.8693848h-16.1796875c-.5527344 0-1-.4477539-1-1s.4472656-1 1-1h16.1796875c.5527344 0 1 .4477539 1 1s-.4472657 1-1 1z"
                fill="#19191a"
                fill-opacity="1"
                data-original-color="#b4b0b9ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m26.1914063 48.161377h-12.8984375c-.5527344 0-1-.4477539-1-1s.4472656-1 1-1h12.8984375c.5527344 0 1 .4477539 1 1s-.4472657 1-1 1z"
                fill="#19191a"
                fill-opacity="1"
                data-original-color="#b4b0b9ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m43.8066406 53.9963379c-2.453125 0-4.90625-.9335938-6.7734375-2.8007813-3.734375-3.734375-3.734375-9.8115234 0-13.5458984 3.734375-3.734375 9.8125-3.734375 13.546875 0s3.734375 9.8115234 0 13.5458984c-1.8671875 1.8671875-4.3203125 2.8007813-6.7734375 2.8007813zm-5.359375-14.9326172c-2.9541016 2.9550781-2.9541016 7.7626953 0 10.7177734 2.9570313 2.9550781 7.765625 2.9550781 10.71875 0 2.9541016-2.9550781 2.9541016-7.7626953 0-10.7177734-2.9550781-2.9541016-7.7636718-2.9541016-10.71875 0z"
                fill="#e55a74"
                fill-opacity="1"
                data-original-color="#e55a74ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
            <g>
              <path
                d="m37.7402344 51.4885254c-.2558594 0-.5117188-.0976563-.7070313-.2929688-.390625-.390625-.390625-1.0234375 0-1.4140625l12.1328125-12.1318359c.390625-.390625 1.0234375-.390625 1.4140625 0s.390625 1.0234375 0 1.4140625l-12.1328125 12.1318359c-.1953125.1953125-.4511718.2929688-.7070312.2929688z"
                fill="#e55a74"
                fill-opacity="1"
                data-original-color="#e55a74ff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
